export const calculateLoanEMI = (loanAmount, tenureYears, annualInterestRate) => {
    const monthlyInterestRate = annualInterestRate / 12 / 100;
    const tenureMonths = tenureYears * 12;
    const emi = (loanAmount * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, tenureMonths)) /
        (Math.pow(1 + monthlyInterestRate, tenureMonths) - 1);

    const totalAmountPayable = emi * tenureMonths; // Total amount to be paid to the bank
    const interestPayable = totalAmountPayable - loanAmount; // Total interest paid
    const interestPercentage = (interestPayable / totalAmountPayable) * 100; // Percentage of interest in total payment

    return {
        loanAmount: Math.round(loanAmount),
        tenureInYears: tenureYears,
        annualInterestRate: annualInterestRate,
        monthlyEMI: Math.round(emi),
        interestPayable: Math.round(interestPayable),
        totalAmountPayable: Math.round(totalAmountPayable),
        interestPercentage: Math.round(interestPercentage) + "%"
    };
}

export const calculateAmortizationSchedule = (loanAmount, tenureYears, annualInterestRate) => {
    const monthlyInterestRate = annualInterestRate / 12 / 100;
    const tenureMonths = tenureYears * 12;

    // Calculate EMI
    const emi = (loanAmount * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, tenureMonths)) /
        (Math.pow(1 + monthlyInterestRate, tenureMonths) - 1);

    let balance = loanAmount;
    let amortizationSchedule = [];

    // Get current date
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed

    for (let i = 0; i < tenureMonths; i++) {
        let interestForMonth = balance * monthlyInterestRate;
        let principalForMonth = emi - interestForMonth;
        balance -= principalForMonth;

        amortizationSchedule.push({
            year: currentYear,
            month: currentMonth,
            emi: emi.toFixed(2),
            principal: principalForMonth.toFixed(2),
            interest: interestForMonth.toFixed(2),
            remainingBalance: balance > 0 ? balance.toFixed(2) : "0.00"
        });

        // Update the month and year
        currentMonth++;
        if (currentMonth > 12) {
            currentMonth = 1;
            currentYear++;
        }
    }

    return amortizationSchedule;
}

export const generateReport = (loanAmount, tenureInYears, annualInterestRate) => {
    const emiReport = calculateLoanEMI(loanAmount, tenureInYears, annualInterestRate);
    const amortizationSchedule = calculateAmortizationSchedule(loanAmount, tenureInYears, annualInterestRate);
    return {
        emiReport,
        amortizationSchedule
    };
};

